<template>
  <m-main-layout>
    <div class="page-content-main">
      <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="auto" class="margin-top">
        <el-form-item label="隐私政策" prop="secret" class="no-line-height">
          <!--                    <editor v-model="formData.service"/>-->
          <vue-ueditor-wrap editor-id="editor-demo-01" v-model="formData.secret" :config="config"></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">确定</el-button>
          <el-button type="" @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </m-main-layout>
</template>

<script>
export default {
  name: "add",
  data() {
    return {
      formData: {
        secret:'',
      },
      rules: {
        secret:[{required:true}],
      },
      config: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        autoFloatEnabled:false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: `${this.$config.editUrl}`,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/ueditor/'
      }
    };
  },
  mounted(){
    this.getDetail();
  },
  methods: {
    submitForm(formName) {
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(_this.formData);
          _this.$http.httpPost({
            url:'/SystemSetting/edit',
            datas:_this.formData,
            success:(res)=>{
              if(res === 'ok'){
                _this.$message.success('修改成功');
              }else{
                _this.$message.error('修改失败');
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getDetail() {
      let _this = this;

      let _skeys = [];

      for(let k in this.formData){
        _skeys.push(k);
      }

      _this.$http.httpPost({
        url:'/SystemSetting/getSystem',
        datas:{skey:_skeys},
        success:(res)=>{
          _this.formData = res;
        }
      });
    }
  }
}
</script>
